module.exports = __webpack_public_path__ + "static/media/web-properties-app.b0704b34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/web-properties-app.jpg
// module id = 973
// module chunks = 0